module.exports = __webpack_public_path__ + "static/media/brands-03-mc@2x.9fbcc28e.png";